// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import * as i from '../interfaces';

export class Template implements i.TemplateInterface {
  partnerId: string;
  siteId: string;
  primaryDomain: string;
  title: string;
  screenshotUrl: string;
  created: Date;
  templateVersion: number;
  isTemplateDistributed: boolean;

  static fromProto(proto: any): Template {
    let m = new Template();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.templateVersion) {
      m.templateVersion = parseInt(proto.templateVersion, 10);
    }
    return m;
  }

  constructor(kwargs?: i.TemplateInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: { [key: string]: any } = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.primaryDomain !== 'undefined') {
      toReturn['primaryDomain'] = this.primaryDomain;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.screenshotUrl !== 'undefined') {
      toReturn['screenshotUrl'] = this.screenshotUrl;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? (this.created as any).toApiJson() : this.created;
    }
    if (typeof this.templateVersion !== 'undefined') {
      toReturn['templateVersion'] = this.templateVersion;
    }
    if (typeof this.isTemplateDistributed !== 'undefined') {
      toReturn['isTemplateDistributed'] = this.isTemplateDistributed;
    }
    return toReturn;
  }
}

export class ListTemplatesRequest implements i.ListTemplatesRequestInterface {
  partnerIds: string[];
  includeUnpublished: boolean;
  creating: boolean;
  cursor: string;
  pageSize: number;

  static fromProto(proto: any): ListTemplatesRequest {
    let m = new ListTemplatesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }

  constructor(kwargs?: i.ListTemplatesRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: { [key: string]: any } = {};
    if (typeof this.partnerIds !== 'undefined') {
      toReturn['partnerIds'] = this.partnerIds;
    }
    if (typeof this.includeUnpublished !== 'undefined') {
      toReturn['includeUnpublished'] = this.includeUnpublished;
    }
    if (typeof this.creating !== 'undefined') {
      toReturn['creating'] = this.creating;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}

export class ListTemplatesResponse implements i.ListTemplatesResponseInterface {
  templates: Template[];
  nextCursor: string;
  hasMore: boolean;

  static fromProto(proto: any): ListTemplatesResponse {
    let m = new ListTemplatesResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(Template.fromProto);
    }
    return m;
  }

  constructor(kwargs?: i.ListTemplatesResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: { [key: string]: any } = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = this.templates.map((t) => ('toApiJson' in t ? (t as any).toApiJson() : t));
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}

export class DeleteTemplateRequest implements i.DeleteTemplateRequestInterface {
  partnerId: string;
  siteId: string;

  static fromProto(proto: any): DeleteTemplateRequest {
    let m = new DeleteTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.DeleteTemplateRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: { [key: string]: any } = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    return toReturn;
  }
}

export class DeleteTemplateResponse implements i.DeleteTemplateResponseInterface {
  siteId: string;
  jobId: string;

  static fromProto(proto: any): DeleteTemplateResponse {
    let m = new DeleteTemplateResponse();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.DeleteTemplateResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: { [key: string]: any } = {};
    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.jobId !== 'undefined') {
      toReturn['jobId'] = this.jobId;
    }
    return toReturn;
  }
}
